module.exports = __webpack_public_path__ + "media/driving_style_de_desktop.9626fc46.webm";